import React from 'react';
import styled from '../index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import { useQuestionStore } from 'lowcomp/plugins/member/member-questions/content/components/QuestionProvider';
import { EcocreditsIcon, CouponIcon } from '@/components/UI/svg/Ecocredits';
import NextImage from '@/components/NextImage';
import getLocal from '@/app/utils/getLocal';
import { textLang } from '../../../textLang';
import EcoImg from 'eco-design/base/eco-img';

// interface ExamHeaderProps {}

const ExamHeader: React.FC<any> = ({}) => {
    const { question, rewardCouponCount, rewardTotalPoints } = useQuestionStore();
    console.log('rewardTotalPoints', rewardTotalPoints);
    // const dispatch = useQuestionDispatch();
    const { locale } = getLocal();
    const lang = textLang[locale as string] || textLang.us;

    const getClassName = (defAns: string, ans?: string) => {
        if (defAns) {
            return defAns === ans ? 'success number' : 'error number';
        }
        return 'number';
    };

    return (
        <div className={styled.exam_header}>
            <div className="number_list">
                {question.map((item, index) => {
                    return (
                        <span className={`${getClassName(item.defAnswer, item.userAnswer)}`} key={item.questionId}>
                            {index < 9 ? `0${index + 1}` : index + 1}
                        </span>
                    );
                })}
            </div>
            <div className="award">
                <span className="points">
                    {rewardTotalPoints} {lang.ecoCredits}
                    <span className="coin 888">
                        <EcoImg pc={'https://websiteoss.ecoflow.com/upload/image/1773902306602/coin.png'} alt={lang.ecoCredits} aria-label={lang.ecoCredits} />
                    </span>
                </span>
                {/* <span className="coupons">
                    {rewardCouponCount} {t('question.coupons')}
                    <CouponIcon />
                    <span className="percent">%</span>
                </span> */}
            </div>
        </div>
    );
};

export default ExamHeader;
